mutation BatchEditApprovalRevoke($input: BatchEditApprovalRevokeInput!) {
  batchEditApprovalRevoke(input: $input) {
    revokedApprovalEntity
  }
}
